<template>
  <div class="detail">
    <div >
      <QS-h3-title >
        <template slot="title">收款信息详情</template>
      </QS-h3-title>
    </div>
    <div class="splitline mt16 mb16" />
    <!-- 收款基础信息 -->
    <CollectionBasisInfo :source="collectionBasisInfo" />
    <!-- 相关应收信息 -->
    <ReceivableInfo :source="source"/>
    <!-- 应收业务信息 -->
    <ReceivableBusinessInfo :source="source" />
  </div>
</template>

<script>
import CollectionBasisInfo from './components/CollectionBasisInfo.vue'
import ReceivableInfo from './components/ReceivableInfo'
import ReceivableBusinessInfo from './components/ReceivableBusinessInfo.vue'

import {
  getReceiptDetails,
} from '@/api/financeApi'

export default {
  components: {
    CollectionBasisInfo,
    ReceivableInfo,
    ReceivableBusinessInfo,
  },
  data() {
    return {
      source: {},
      collectionBasisInfo: {},
    }
  },
  created() {
    const { id } = this.$route.query
    this.getReceiptDetails(id)
  },
  methods: {
    getReceiptDetails(id) {
      getReceiptDetails({ id }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.collectionBasisInfo = {
            ...data,
            customerType: data.receivableInfo.customerType,
            amount: this.numberWithCommas(data.amount), // 收款金额
            photo: this.getURL({ data: data.photo, needName: true }),
          }
          this.source = {
            ...data.receivableInfo,
            receivableAmount: this.numberWithCommas(data.receivableAmount), // 应收金额
            receivedAmount: this.numberWithCommas(data.receivedAmount), // 应收金额
          }
        }
      })
    },
  },
}
</script>

<style>

</style>
